module.exports = __webpack_public_path__ + "img/lines-sm.06fea8c1.svg";